import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

import { FormSection } from '../../components/forms/FormSection';
import { FormStack } from '../../components/forms/FormStack';
import { useCreatePasswordChangeTicketUrlMutation } from '../../graphql/hooks/useCreatePasswordChangeTicketUrlMutation';
import { useAppContext } from '../../hooks/useAppContext';

export const SecuritySettings = () => {
  const { organization } = useAppContext();

  const resetPasswordMutation = useCreatePasswordChangeTicketUrlMutation();

  const resetPassword = async () => {
    const resp = await resetPasswordMutation.mutateAsync({ organizationId: organization.id });
    window.location.href = resp.createPasswordChangeTicketUrl;
  };

  return (
    <FormStack maxW='lg'>
      <FormSection heading='Security' description='Manage your password here'>
        <ChakraV3.Separator />
        <ChakraV3.FormField helperText='You can request a new password. You will be emailed a link to reset it.'>
          <ChakraV3.HStack>
            <ChakraV3.Button
              onClick={resetPassword}
              loading={resetPasswordMutation.isLoading}
              colorPalette='brand'
              size='sm'
            >
              Reset password
            </ChakraV3.Button>
          </ChakraV3.HStack>
        </ChakraV3.FormField>
      </FormSection>
    </FormStack>
  );
};
